import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-pendentes-cancelamento',
  templateUrl: './contratos-pendentes-cancelamento.component.html',
  styleUrl: './contratos-pendentes-cancelamento.component.css'
})
export class ContratosPendentesCancelamentoComponent {

}
